import React, { useState } from 'react';
import SupplierMenu from './SupplierMenu';
import SupplierStats from './SupplierStats';
import SupplierHistory from './SupplierHistory'; // ✅ Новый импорт

const CustomerPanel = () => {
  const [activeTab, setActiveTab] = useState('menu');

  return (
    <div className="text-white p-6 max-w-6xl mx-auto space-y-8">
      <h1 className="text-3xl font-bold text-center text-teal-400 mb-6">
        👨‍🍳 Панель поставщика
      </h1>

      <div className="flex justify-center gap-4 mb-4 flex-wrap">
        <button
          onClick={() => setActiveTab('menu')}
          className={`px-4 py-2 rounded shadow text-sm font-medium ${
            activeTab === 'menu'
              ? 'bg-teal-600 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-gray-200'
          }`}
        >
          🍱 Меню
        </button>

        <button
          onClick={() => setActiveTab('stats')}
          className={`px-4 py-2 rounded shadow text-sm font-medium ${
            activeTab === 'stats'
              ? 'bg-teal-600 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-gray-200'
          }`}
        >
          📊 Статистика
        </button>

        <button
          onClick={() => setActiveTab('history')}
          className={`px-4 py-2 rounded shadow text-sm font-medium ${
            activeTab === 'history'
              ? 'bg-teal-600 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-gray-200'
          }`}
        >
          📜 История
        </button>
      </div>

      {/* Отображение активного компонента */}
      {activeTab === 'menu' && <SupplierMenu />}
      {activeTab === 'stats' && <SupplierStats />}
      {activeTab === 'history' && <SupplierHistory />}
    </div>
  );
};

export default CustomerPanel;
